var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGate3DecisionMemo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 8.49951H11.5008C11.103 8.49951 10.7215 8.65756 10.4403 8.93889C10.159 9.22022 10.001 9.60178 10.001 9.99963V22.0006C10.001 22.3984 10.159 22.78 10.4403 23.0613C10.7215 23.3427 11.103 23.5007 11.5008 23.5007H20.4999C20.8977 23.5007 21.2792 23.3427 21.5605 23.0613C21.8418 22.78 21.9998 22.3984 21.9998 22.0006V12.9999M17.5002 8.49951C17.7376 8.49913 17.9727 8.54572 18.1921 8.6366C18.4114 8.72748 18.6105 8.86086 18.7781 9.02906L21.4688 11.7203C21.6374 11.8879 21.7712 12.0873 21.8623 12.3069C21.9534 12.5266 22.0002 12.7621 21.9998 12.9999M17.5002 8.49951V12.2498C17.5002 12.4487 17.5792 12.6395 17.7199 12.7802C17.8605 12.9208 18.0513 12.9999 18.2501 12.9999L21.9998 12.9999M14.5005 13.7499H13.0007M19.0001 16.7502H13.0007M19.0001 19.7504H13.0007",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate3DecisionMemo);
export default __webpack_public_path__ + "static/media/Gate3_DecisionMemo.998fe1325407bf6796a77c356dc31ee9.svg";
export { ForwardRef as ReactComponent };